export default "__VITE_ASSET__BCXRtjXx__"